import { render, staticRenderFns } from "./FontFaminy.vue?vue&type=template&id=3f2ab52c&"
import script from "./FontFaminy.vue?vue&type=script&lang=js&"
export * from "./FontFaminy.vue?vue&type=script&lang=js&"
import style0 from "./FontFaminy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports